window.MonnifyConfig = window.MonnifyConfig || {};
export default window.MonnifyConfig;

export function isTestEnvironment(paymentData) {
  // return true;
  return !paymentData?.apiKey.startsWith("MK_PROD_");
}
